/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-lone-blocks */
import React, { useEffect, useRef, useState } from "react";
import { Button } from "../components/Button";
import { Card } from "../components/Card";
import { CardContent } from "../components/CardContent";
import Papa from "papaparse";

import { database, ref, push } from "../../firebaseConfig";
import { get, runTransaction } from "firebase/database";
import instructionVid from "../../Videos/Instruction-Video.mov";



function IntroScreen({ onDone }) {
  const [videoDuration, setVideoDuration] = useState(0);
  const [watchedEnough, setWatchedEnough] = useState(false);
  const videoRef = useRef(null);
  const watchedSecondsRef = useRef(new Set());

  const handleTimeUpdate = () => {
    const v = videoRef.current;
    if (!v) return;
    const t = Math.floor(v.currentTime);
    watchedSecondsRef.current.add(t);
    if (videoDuration > 0) {
      const ratio =
        watchedSecondsRef.current.size / Math.max(1, Math.floor(videoDuration));
      if (ratio >= 0.98) setWatchedEnough(true);
    }
  };

  const handleLoadedMeta = () => {
    const v = videoRef.current;
    if (!v) return;
    setVideoDuration(v.duration || 0);
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-3xl bg-white rounded-xl shadow p-6">
        <h1 className="text-2xl font-bold text-center mb-4">
          Video Tool Guide (Please watch before continuing)
        </h1>

        <video
          ref={videoRef}
          src={instructionVid}
          controls
          playsInline
          className="block mx-auto w-full rounded-lg"
          onLoadedMetadata={handleLoadedMeta}
          onTimeUpdate={handleTimeUpdate}
          onEnded={() => setWatchedEnough(true)}
        />

        <div className="mt-6 flex justify-center">
          <button
            className={
              watchedEnough
                ? "px-5 py-2 rounded text-white bg-blue-600 hover:bg-blue-700"
                : "px-5 py-2 rounded text-white bg-gray-400 cursor-not-allowed"
            }
            disabled={!watchedEnough}
            onClick={onDone}
          >
            Next: Select Article Index
          </button>
        </div>

        <p className="mt-3 text-xs text-center text-gray-500">
          You must watch the full video before continuing.
        </p>
      </div>
    </div>
  );
}

function TaskClosedScreen() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-100">
      <div className="w-full max-w-2xl bg-white rounded-xl shadow p-8 border border-gray-200 text-center">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-4">Task Closed</h1>
        <p className="text-gray-700 leading-relaxed mb-2">
          This task is no longer accepting responses because the required number of annotations has been completed.
        </p>
        <p className="text-gray-700 leading-relaxed mb-2">
          You may safely return or exit the HIT without submitting.
        </p>
        <p className="text-gray-700 leading-relaxed">Thank you for your interest.</p>
      </div>
    </div>
  );
}

// --- Selection constraints ---
const MIN_WORDS = 1;
const MAX_WORDS = 25;

const countWords = (t = "") => (t.trim() ? t.trim().split(/\s+/).length : 0);


// Utility to fix misencoded characters, where any characters not from English
// would be changed through UTF-8 encoding, leaving characters like é mangled as √©. 
// The CSV file is already encoded incorrectly, so this code is trying to fix that. 
// adds paragraph breaks after 100 words. 
function paragraphAdd(text) {
  const words = text.split(/\s+/);
  const paragraphs = [];
  let paragraph = "";
  let wordCount = 0;
  let insideQuote = false;

  const quoteMatches = text.match(/["“”]/g) || [];
  const trackQuotes = (quoteMatches.length % 2 === 0);

  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    paragraph += word + " ";
    wordCount++;

    // Detect quote entry/exit
    if (trackQuotes && /["“”]/.test(word)) {
      const q = (word.match(/["“”]/g) || []).length;
      if (q % 2 !== 0) insideQuote = !insideQuote;
    }

    const isSentenceEnd = /[.!?][”"')\]]*$/.test(word);

    // Only insert break if:
    // - 150+ words
    // - Ends with a period
    // - Not inside a quote
    if (wordCount >= 150 && isSentenceEnd && (!trackQuotes || !insideQuote)) {
      paragraphs.push(paragraph.trim());
      paragraph = "";
      wordCount = 0;
    }
  }

  if (paragraph.trim()) {
    paragraphs.push(paragraph.trim());
  }

  return paragraphs;
}
// loops through the title and capitalizes all non-conjunction words
function titleCapitalization(title){ 
  const titleWords = title.split(" ");
  const conjunctions = ["a", "to", "off", "over", "from", "into", "with", "yet", "so", "an", "and", "as", "at", "but", "by", "for", "in", "nor", "of", "on", "or", "the", "up"];
  for (let i = 0; i < titleWords.length; i++) {
    if (!(conjunctions.includes(titleWords[i]))){
      // if the title word is not a conjunction, make it caps 
      titleWords[i] = titleWords[i].charAt(0).toUpperCase() + titleWords[i].slice(1);
    }
  }
  return titleWords.join(" ");

}

// Function to shuffle array randomly

/*
TEMPORARILY COMMENTED OUT WHILE WE MANUALLY SET ARTICLES FOR TESTING :) 
const shuffleArray = (array) => {
  return array.sort(() => Math.random() - 0.5);
};
*/

const DropdownItem = ({ icon, title, children, openTitle, setOpenTitle, color }) => {
  const isOpen = openTitle === title;
  const handleClick = () => setOpenTitle(isOpen ? null : title);

  const borderColor =
    color === "yellow"
      ? "border-yellow-400"
      : color === "red"
      ? "border-red-400"
      : "border-blue-400";

  return (
    <div
      className={`mb-3 rounded-lg transition-all duration-300 ${
        isOpen
          ? `bg-white/70 ${borderColor} border-l-4 shadow-sm`
          : "hover:bg-gray-50"
      }`}
    >
      <button
        onClick={handleClick}
        className="flex items-center justify-between w-full text-left text-base font-semibold text-gray-900 hover:text-blue-600 focus:outline-none px-2 py-2"
      >
        <span className="flex items-center space-x-2">
          {icon && <span>{icon}</span>}
          <span>{title}</span>
        </span>
        <span
          className={`text-xl leading-none transition-transform duration-300 ${
            isOpen ? "rotate-90 text-blue-500" : "rotate-0 text-gray-500"
          }`}
        >
          {isOpen ? "−" : "+"}
        </span>
      </button>

      {isOpen && (
        <div className="mt-2 ml-3 mr-2 text-left text-gray-800 transition-all duration-300 space-y-2 leading-relaxed">
          {children}
        </div>
      )}
    </div>
  );
};


function ToolMain() {
    console.log("YAY Loaded NewsAnnotationTool");
    const [introDone, setIntroDone] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null); 
    const [showNoPolarizingPopup, setShowNoPolarizingPopup] = useState(false);
    const [pendingNoPolarizingConfirm, setPendingNoPolarizingConfirm] = useState(false); // commented out the variable pendingNoPolarizingConfirm
    const [taskClosed, setTaskClosed] = useState(false);
    const [selectedArticleIndexInput, setSelectedArticleIndexInput] = useState("");
    const [articleSelectionError, setArticleSelectionError] = useState("");
    const [completionCode, setCompletionCode] = useState("");
    const [allArticles, setAllArticles] = useState([]);
    const [articles, setArticles] = useState([]);
    const [currentArticleIndex, setCurrentArticleIndex] = useState(0);
    const [annotations, setAnnotations] = useState({});
    const [selectedText, setSelectedText] = useState("");
    const [textAnnotations, setTextAnnotations] = useState({});
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedSubcategory, setSelectedSubcategory] = useState("");
    const [showRightInstructions, setShowRightInstructions] = useState(true);
    const [wordCount, setWordCount] = useState(0);
    const [currentParagraphIndex, setCurrentParagraphIndex] = useState(0);
    const [selectionParagraphIndex, setSelectionParagraphIndex] = useState(null);

    // --- Subcategory confirmation popup (mirrors No Polarizing Language flow) ---
    const [showSubcategoryPopup, setShowSubcategoryPopup] = useState(false);
    const [pendingSubcategoryAnnotation, setPendingSubcategoryAnnotation] = useState(null);

    const currentArticle = articles[currentArticleIndex];
    const paragraphs = currentArticle ? paragraphAdd(currentArticle.content) : [];
    const hasMoreParagraphs = currentArticle ? currentParagraphIndex < paragraphs.length - 1 : false;


    const handleCategoryButtonClick = (categoryKey) => {
      const wc = countWords(selectedText);
    
      // For all categories except "No_Polarizing_Language", enforce the word-count rule
      if (categoryKey !== "No_Polarizing_Language" && (wc < MIN_WORDS || wc > MAX_WORDS)) {
        alert(`Please select between ${MIN_WORDS} and ${MAX_WORDS} words before annotating.`);
        return;
      }
    
      setSelectedCategory(categoryKey);
      setSelectedSubcategory("");
    
      // No Polarizing Language popup DISABLED (record immediately)
      if (categoryKey === "No_Polarizing_Language") {
        const articleId = articles[currentArticleIndex]?.id;
        if (articleId) {
          setTextAnnotations((prev) => ({
            ...prev,
            [articleId]: [
              ...(prev[articleId] || []),
              {
                title: articles[currentArticleIndex]?.title || "",
                text: "no polarizing language selected",
                category: "No_Polarizing_Language",
                subcategory: "no polarizing language",
                paragraphIndex: currentParagraphIndex,
              },
            ],
          }));
        }
        // Ensure popup state stays off
        setShowNoPolarizingPopup(false);
        setPendingNoPolarizingConfirm(false);
        return;
      }
      // Regular categories behave normally
    };
    

    // Live word count only
useEffect(() => {
  const handleSelectionChange = () => {
    const selection = window.getSelection();
    setWordCount(countWords(selection.toString().trim()));
  };

  document.addEventListener("selectionchange", handleSelectionChange);
  return () => document.removeEventListener("selectionchange", handleSelectionChange);
}, []);

    useEffect(() => {
      setCurrentParagraphIndex(0);
      setSelectionParagraphIndex(null);
      setSelectedText("");
    }, [currentArticleIndex]);

    const categoryOptions = {
      Persuasive_Propaganda: ["Exaggeration", "Slogans", "Bandwagon", "Casual Oversimplification", "Doubt"],
      Inflammatory_Language: ["Demonization", "Name-Calling", "Scapegoating"],
      "No_Polarizing_Language": ["No polarizing language"],
  };

    const subcategoryPopupContent = {
      Exaggeration: {
        title: "Exaggeration",
        description:
          "Makes something sound much bigger, better, or worse than it really is (or downplays it as smaller or less serious).",
        examples: [
          "“A local protest ignited waves of outrage and sent shockwaves through the nation.”",
          "“This minor disagreement has become a national catastrophe.”",
        ],
      },
      Slogans: {
        title: "Slogans",
        description:
          "A short, memorable phrase meant to spark emotion or support a cause by simplifying a complex idea into a few words.",
        examples: ["“No Justice, No Peace.”", "“America First.”"],
      },
      Bandwagon: {
        title: "Bandwagon",
        description:
          "Urges support because “everyone else” supports it—relying on popularity or social pressure rather than evidence.",
        examples: ["“Most Americans back this plan, polls show.”"],
      },
      "Casual Oversimplification": {
        title: "Casual Oversimplification",
        description:
          "Explains a complex issue with one simple cause or answer, ignoring other factors that are probably involved.",
        examples: [
          "“The media is the only reason the nation is divided.”",
          "“Inflation rose solely because of the president’s policies.”",
        ],
      },
      Doubt: {
        title: "Doubt",
        description:
          "Language that makes the audience question whether a person, group, or institution is competent, honest, or legitimate.",
        examples: [
          "“Is he really ready to be the Mayor?”",
          "“Some experts question whether the agency’s data can be trusted.”",
        ],
      },
      "Name-Calling": {
        title: "Name-Calling",
        description:
          "Uses a loaded positive or negative label to shape how the audience feels about a person, group, or idea instead of evidence.",
        examples: [
          "“The movement, composed largely of radical extremists, has demanded sweeping reform.”",
          "“The oft-labeled terrorist sympathizers took to the streets…”",
        ],
      },
      Demonization: {
        title: "Demonization",
        description:
          "Describes people or groups as evil, dangerous, corrupt, disgusting, or less than human to turn the audience against them.",
        examples: [
          "“Migrants are parasites stealing American jobs.”",
          "“These politicians are eating away at the heart of this nation…”",
        ],
      },
      Scapegoating: {
        title: "Scapegoating",
        description:
          "Blames an entire group for a broad problem or crisis and frames them as the main cause of widespread harm or decline.",
        examples: [
          "“Teachers’ unions are the reason kids are failing in school.”",
          "“The rising rents—driven as always by greedy landlords—represent a severe strain on families.”",
        ],
      },
    };

    const getSubcategoryPopupCopy = (subcategory) => {
      if (!subcategory) {
        return {
          title: "Are you sure?",
          description:
            "Confirm your choice before saving this annotation. If it doesn't fit, cancel and pick a different subcategory.",
          examples: [],
        };
      }
      return (
        subcategoryPopupContent[subcategory] || {
          title: subcategory,
          description:
            "Confirm your choice before saving this annotation. If it doesn't fit, cancel and pick a different subcategory.",
          examples: [],
        }
      );
    };

    const [showSurvey, setShowSurvey] = useState(false);
    const [surveyResponses, setSurveyResponses] = useState({});
    const [confidence, setConfidence] = useState(0);
    const [bias, setBias] = useState(0);
    const [openFeedback, setOpenFeedback] = useState("");
    const [showThankYou, setShowThankYou] = useState(false);

    const articleId = articles[currentArticleIndex]?.id;
    const pendingSubcategoryCopy = pendingSubcategoryAnnotation
      ? getSubcategoryPopupCopy(pendingSubcategoryAnnotation.subcategory)
      : null;


    // Annotations for current article and paragraph-based progress
    const annotationsForArticle = articleId ? (textAnnotations[articleId] || []) : [];
    const paragraphsAnnotated = new Set(
      annotationsForArticle
        .filter((a) => a.paragraphIndex !== undefined && a.paragraphIndex !== null)
        .map((a) => a.paragraphIndex)
    );
    const hasAnnotationInCurrentParagraph = paragraphsAnnotated.has(currentParagraphIndex);
    const allParagraphsAnnotated =
      paragraphs.length > 0 &&
      paragraphs.every((_, idx) => paragraphsAnnotated.has(idx));

    const countCharacters = (text) => {
      return text.trim().length;
    };

const saveAnnotation = ({
  articleId: targetArticleId,
  title = "",
  text,
  category,
  subcategory,
  paragraphIndex,
}) => {
  if (!targetArticleId || !category || !subcategory) return;

  setTextAnnotations((prevAnnotations) => ({
    ...prevAnnotations,
    [targetArticleId]: [
      ...(prevAnnotations[targetArticleId] || []),
      {
        title,
        text,
        category,
        subcategory,
        paragraphIndex,
      },
    ],
  }));

  // Reset selection UI
  setSelectedText("");
  setSelectedCategory("");
  setSelectedSubcategory("");
  setSelectionParagraphIndex(null);
};

// Update category and subcategory selection handlers
const handleCategoryChange = (e) => {
  const newCategory = e.target.value;

  // Changing category should reset subcategory selection
  setSelectedCategory(newCategory);
  setSelectedSubcategory("");

  // If someone selects "No polarizing language" from the dropdown (rare),
  // reuse the same confirmation flow as the dedicated button.
  if (newCategory === "No_Polarizing_Language") {
    // No Polarizing Language popup DISABLED (record immediately)
    const articleId = articles[currentArticleIndex]?.id;
    if (articleId) {
      setTextAnnotations((prev) => ({
        ...prev,
        [articleId]: [
          ...(prev[articleId] || []),
          {
            title: articles[currentArticleIndex]?.title || "",
            text: "No polarizing language selected",
            category: "No_Polarizing_Language",
            subcategory: "no polarizing language",
            paragraphIndex: currentParagraphIndex,
          },
        ],
      }));
    }
    setShowNoPolarizingPopup(false);
    setPendingNoPolarizingConfirm(false);
  }
};

const handleSubcategoryChange = (e) => {
  const newSubcategory = e.target.value;
  setSelectedSubcategory(newSubcategory);

  if (!newSubcategory) return;

  // We only show the subcategory popup for actual polarizing categories.
  if (selectedCategory === "No_Polarizing_Language") {
    return;
  }

  // Enforce word-count rule before allowing a subcategory confirmation
  const wc = countWords(selectedText);
  if (wc < MIN_WORDS || wc > MAX_WORDS) {
    alert(`Please select between ${MIN_WORDS} and ${MAX_WORDS} words before annotating.`);
    setSelectedSubcategory("");
    return;
  }

  const articleIdNow = articles[currentArticleIndex]?.id;
  if (!articleIdNow || !selectedText) return;

  setPendingSubcategoryAnnotation({
    articleId: articleIdNow,
    title: articles[currentArticleIndex]?.title || "",
    text: selectedText,
    category: selectedCategory,
    subcategory: newSubcategory,
    paragraphIndex: selectionParagraphIndex ?? currentParagraphIndex,
  });
  setShowSubcategoryPopup(true);
};

const downloadAnnotations = (annotations, textAnnotations, surveyResponses) => {
  const articleTitles = articles.map((article) => ({
      id: article.id,
      title: titleCapitalization(articles.title), //applies capitalization to each article
  }));
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-");

  const data = {
    annotations,
    textAnnotations,
    surveyResponses,
    articleTitles,
    timestamp: new Date().toISOString(),
  };
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `annotations_${timestamp}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
      
    // RANDOM ARTICLE SELECTION (COMMENTED OUT)
    // useEffect(() => {
    //     setArticles(shuffleArray([...sampleArticles]));
    // }, []);

    // function getThreeUniqueInts() {
    //   const numbers = new Set();
    
    //   while (numbers.size < 3) {
    //     const rand = Math.floor(Math.random() * (552 - 2 + 1)) + 2;
    //     numbers.add(rand); // Set ensures uniqueness
    //   }
    
    //   return Array.from(numbers);
    // }

    // console.log(getThreeUniqueInts());

    // const dict = {};
    // for (let i = 2; i <= 552; i++) {
    //   dict[i.toString()] = 0;
    // }

    // console.log(dict);

    // const testRef = ref(database, "test");
    // push(testRef, dict)
    //   .then(() => {
    //     console.log("Test data saved to Firebase");
    //   })
    //   .catch((error) => {
    //     console.error("Error saving to Firebase:", error);
    //   });


    // const submissionsRef = ref(database, "submissions");
    // push(submissionsRef, data)
    //   .then(() => {
    //     console.log("Submission saved to Firebase");
    //   })
    //   .catch((error) => {
    //     console.error("Error saving to Firebase:", error);
    //   });

    

    // HARD-CODED ARTICLE SELECTION


    
    // ORIGINAL RANDOM SELECTION (COMMENTED OUT)
    /*
    useEffect(() => {
        fetch("/new_filtered_news_300_700_words.csv")
        .then((response) => response.text())
        .then((csvText) => {
          Papa.parse(csvText, {
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
              const parsedArticles = results.data.map((item, index) => ({
                id: index + 1,
                title: item["Headline"],
                content: item["News body"],
            }));
            const randomArticles = shuffleArray(parsedArticles).slice(0, 3);
            setArticles(randomArticles);
            },
          });
        });
    }, []);
    */
    /*
        setArticles(shuffleArray([...sampleArticles.slice(0, 3)]));
      }, []);
    */

const MAX_PER_ARTICLE = 10;

async function assignArticleIndex(requestedIndex) {
  const usageRef = ref(database, "articleUsage");
  let chosenIndex = Number(requestedIndex);

  if (!Number.isInteger(chosenIndex) || chosenIndex < 0 || chosenIndex >= 27) {
    console.warn("Invalid article index selected.");
    return null;
  }

  const result = await runTransaction(usageRef, (curr) => {
    const usage = curr ?? {};

    for (let i = 0; i < 27; i++) {
      if (usage[i] === undefined) usage[i] = 0;
    }

    if ((usage[chosenIndex] ?? 0) >= MAX_PER_ARTICLE) {
      return;
    }

    usage[chosenIndex] = (usage[chosenIndex] ?? 0) + 1;
    return usage;
  });

  if (!result.committed) {
    console.warn(`Article index ${chosenIndex} is no longer available.`);
    return null;
  }

  console.log(`Assigned selected index and logged usage immediately: ${chosenIndex}`);
  return chosenIndex;
}

  useEffect(() => {
  fetch("/article_dataset_versions/27Articles.csv")
    .then((response) => response.text())
    .then(async (csvText) => {
      Papa.parse(csvText, {
        header: true,
        skipEmptyLines: true,
        complete: async function (results) {
          const parsedArticles = results.data.map((item, index) => ({
            id: index + 1,
            title: item["Headline"],
            content: item["News body"],
          }));
          setAllArticles(parsedArticles);
        },
      });
    });
}, []);

const handleSelectedArticleStart = async () => {
  const requestedIndex = Number(selectedArticleIndexInput);

  if (!Number.isInteger(requestedIndex) || requestedIndex < 0 || requestedIndex >= allArticles.length) {
    setArticleSelectionError(`Please enter a valid article index from 0 to ${Math.max(0, allArticles.length - 1)}.`);
    return;
  }

  const idx = await assignArticleIndex(requestedIndex);
  if (idx !== null && allArticles[idx]) {
    setArticles([allArticles[idx]]);
    setCurrentArticleIndex(0);
    setArticleSelectionError("");
  } else {
    setArticleSelectionError("That article has already reached the maximum number of allowed annotations. Please choose another index.");
  }
};
  

const handleNextArticle = async () => {
  console.log("ARTICLE LENGTH:", articles.length);

  // Require at least one annotation on each paragraph before allowing submit
  if (!allParagraphsAnnotated) {
    alert("Please make at least one annotation on each paragraph before submitting.");
    return;
  }

  // Also ensure the user has stepped through all paragraphs
  if (hasMoreParagraphs) {
    alert("Please read and annotate each paragraph before submitting the article.");
    return;
  }
  if (articles.length > 1) {
    return;
  }
  const articleId = articles[currentArticleIndex]?.id;
  if((textAnnotations[articleId] || []).length < 1){
    alert("Please Annotate Before Submitting");
    return;
  }

  if (showSurvey) {
    // validate survey responses
    if (confidence === 0 || bias === 0) {
      alert("Please answer all survey questions before continuing.");
      return;
    }

    const articleId = articles[currentArticleIndex]?.id;
    const annotationsForArticle = textAnnotations[articleId] || [];

    // Check if "no polarizing language" has been selected
    const hasNoPolarizingLanguage = annotationsForArticle.some(
      (a) =>
        a.category === "No_Polarizing_Language" &&
        a.subcategory === "no polarizing language"
    );

    if (annotationsForArticle.length === 0 && !hasNoPolarizingLanguage) {
      alert(
        "Please annotate at least one phrase or select 'no polarizing language' before continuing."
      );
      return;
    }

    const anyInvalid = annotationsForArticle.some(
      (a) => !a.category || !a.subcategory
    );

    if (anyInvalid) {
      alert("Each annotation must include a category and subcategory.");
      return;
    }

    // Save survey responses
    setSurveyResponses((prev) => ({
      ...prev,
      [articleId]: { confidence, bias, openFeedback },
    }));

    // reset survey UI state
    setSelectedText("");
    setSelectedCategory("");
    setSelectedSubcategory("");
    setShowSurvey(false);
    setConfidence(0);
    setBias(0);
    setOpenFeedback("");

    if (articles.length >= 1) {
      console.log("User has completed 1 articles this session.");
      setShowThankYou(true);
      return;
    } else {
      setShowThankYou(true);
    }
  } else {
    // flip to survey view
    setShowSurvey(true);
  }
};

    

    const handleAnnotation = (label) => {
        const articleId = articles[currentArticleIndex]?.id;
        if (!articleId) return;

        setAnnotations((prevAnnotations) => ({
            ...prevAnnotations,
            [articleId]: label,
        }));

        alert(`Article labeled as: ${label}`);
    };

    const handleTextSelection = (paragraphIndex = null) => {
        const selection = window.getSelection();
        const text = selection.toString().trim();
        if (text !== "") {
            setSelectedText(text);
            setSelectionParagraphIndex(paragraphIndex);
        }
    };

    const handleUnlockNextParagraph = () => {
        const articleId = articles[currentArticleIndex]?.id;
        if (!articleId) return;

        const annotationsForArticle = textAnnotations[articleId] || [];

        const hasAnnotationInCurrentParagraph = annotationsForArticle.some(
            (a) => a.paragraphIndex === currentParagraphIndex
        );

        if (!hasAnnotationInCurrentParagraph) {
            alert("Please make at least one annotation in this paragraph before moving on.");
            return;
        }

        if (currentParagraphIndex < paragraphs.length - 1) {
            setCurrentParagraphIndex((prev) => prev + 1);
            setSelectedText("");
            setSelectionParagraphIndex(null);
        }
    };

    const handleTextAnnotation = () => {
        if (selectedCategory && selectedSubcategory && (selectedText || selectedCategory === "No_Polarizing_Language")) {
            const articleId = articles[currentArticleIndex]?.id;
            const textToSave = selectedCategory === "No_Polarizing_Language" 
              ? "no polarizing language selected" 
              : selectedText;
            
            setTextAnnotations((prevAnnotations) => ({
                ...prevAnnotations,
                [articleId]: [
                    ...(prevAnnotations[articleId] || []),
                    { title: articles[currentArticleIndex]?.title || "", 
                      text: textToSave, 
                      category: selectedCategory, 
                      subcategory: selectedSubcategory },
                ],
            }));
            setSelectedText("");
            setSelectedCategory("");
            setSelectedSubcategory("");
        } else {
            alert("Please select xa high-level category and a subcategory.");
        }
    };

    const handleRemoveAnnotation = (articleId, index) => {
        setTextAnnotations((prevAnnotations) => {
            const updatedAnnotations = [...(prevAnnotations[articleId] || [])];
            updatedAnnotations.splice(index, 1);
            return {
                ...prevAnnotations,
                [articleId]: updatedAnnotations,
            };
        });
    };

    

    // useEffect(() => {
    //     if (showThankYou) {
    //       downloadAnnotations(annotations, textAnnotations, surveyResponses);
    //     }
    //   }, [showThankYou]);
    const generateCode = () => `MTURK-${Math.random().toString(36).substring(2, 8).toUpperCase()}`;

    useEffect(() => {
        if (showThankYou) {

          const code = generateCode();
          setCompletionCode(code);
            const articleTitles = articles.map((article) => ({
                id: article.id,
                title: article.title,
            }))
          const data = {
            annotations,
            textAnnotations,
            surveyResponses,
            articleTitles,
            timestamp: new Date().toISOString(),
            code,
          };
    
          const submissionsRef = ref(database, "Bagozzi-Annotations");
          push(submissionsRef, data)
            .then(() => {
              console.log("Submission saved to Firebase");
            })
            .catch((error) => {
              console.error("Error saving to Firebase:", error);
            });
        }
      }, [showThankYou]);

    

      if (taskClosed) {
        return <TaskClosedScreen />;
      }

      if (showThankYou) {
  return (
    <div className="w-full h-screen flex items-center justify-center bg-white">
      <div className="max-w-xl text-center p-6 border border-gray-300 rounded shadow">
        <h2 className="text-2xl font-bold mb-4">🎉 Thank You!</h2>
        <p className="mb-4 text-gray-700">
          Thank you for taking part in this study. Your responses have been recorded.
        </p>
        <p className="mb-4 text-gray-700">
          Please copy and paste the following completion code into MTurk:
        </p>
        <div className="bg-gray-100 text-lg font-mono p-4 rounded border border-dashed border-gray-400 mb-4">
          {completionCode}
        </div>
        <p className="text-sm text-gray-500">
          You may now close this window or return to the task page.
        </p>

        {process.env.NODE_ENV !== "production" && (
          <Button
            onClick={() =>
              downloadAnnotations(annotations, textAnnotations, surveyResponses)
            }
            className="mt-4 bg-purple-600 text-white"
          >
            Download All Responses (JSON)
          </Button>
        )}
      </div>
    </div>
  );
}
      if (articles.length === 0) {
        if (!introDone) return <IntroScreen onDone={() => setIntroDone(true)} />;
        return (
          <div className="min-h-screen w-full flex items-center justify-center bg-gray-100">
            <div className="w-full max-w-md bg-white rounded-xl shadow p-6 text-center">
              <h1 className="text-2xl font-bold mb-4">Select Article Index</h1>
              <p className="text-sm text-gray-700 mb-4">
                Enter an article index from 0 to {Math.max(0, allArticles.length - 1)}.
              </p>

<div className="mt-5 bg-gray-50 border border-gray-200 rounded-lg p-4 text-left">
  <p className="text-sm font-semibold text-gray-800 mb-2">
    Please read these definitions carefully before starting:
  </p>

  <div className="mb-4">
    <p className="font-bold text-yellow-700 mb-1">Persuasive Propaganda</p>
    <p className="text-sm text-gray-700 leading-relaxed">
      Uses repeated, agenda-driven messaging to shape people’s beliefs or loyalty over time. It often relies on selective facts, framing, slogans, or repetition. The main goal is persuasion.
    </p>
  </div>

  <div>
    <p className="font-bold text-red-700 mb-1">Inflammatory Language</p>
    <p className="text-sm text-gray-700 leading-relaxed">
      Uses hostile, charged, or insulting words to trigger an immediate emotional reaction. It is meant to spark anger, fear, outrage, or division. The main goal is provocation.
    </p>
  </div>
</div>
              <input
                type="number"
                min="0"
                max={Math.max(0, allArticles.length - 1)}
                value={selectedArticleIndexInput}
                onChange={(e) => setSelectedArticleIndexInput(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded mb-3 text-center"
                placeholder="Example: 0"
                disabled={allArticles.length === 0}
              />
              {articleSelectionError && (
                <p className="text-sm text-red-600 mb-3">{articleSelectionError}</p>
              )}
              <Button
                onClick={handleSelectedArticleStart}
                className="bg-blue-600 text-white w-full"
                disabled={allArticles.length === 0 || selectedArticleIndexInput === ""}
              >
                Start Annotation
              </Button>
            </div>
          </div>
        );
      }

      return (
        <div className="flex w-full justify-center items-start min-h-screen bg-gray-100 relative">
          {/* --- No Polarizing Language Confirmation Overlay --- */}
          {false && showNoPolarizingPopup && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm transition-opacity duration-300">
              <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center animate-fadeIn">
                <h2 className="text-2xl font-bold mb-3 text-gray-900">Are you sure?</h2>
                <p className="text-sm text-gray-700 mb-6 leading-relaxed">
                  Selecting this option will trigger a closer review of your work.
                  <br /><br />
                  If the article truly contains <em>no polarizing language</em>,
                  click <strong>“I’m sure.”</strong> Otherwise, review the text again before submitting.
                </p>
      
                <div className="flex justify-center space-x-4">
                <Button
                  onClick={() => {
                    // Close popup
                    setShowNoPolarizingPopup(false);
                    setPendingNoPolarizingConfirm(false);

                    // Clear any "No Polarizing Language" selection
                    if (selectedCategory === "No_Polarizing_Language") {
                      setSelectedCategory("");
                      setSelectedSubcategory("");
                    }
                  }}
                  className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded"
                >
                  Cancel
                </Button>
                  <Button
                    onClick={() => {
                      const articleId = articles[currentArticleIndex]?.id;
                      if (articleId) {
                        setTextAnnotations((prev) => ({
                          ...prev,
                          [articleId]: [
                            ...(prev[articleId] || []),
                            {
                              title: articles[currentArticleIndex]?.title || "",
                              text: "No polarizing language selected",
                              category: "No_Polarizing_Language",
                              subcategory: "no polarizing language",
                              paragraphIndex: currentParagraphIndex,
                            },
                          ],
                        }));
                      }
                      setShowNoPolarizingPopup(false);
                      setPendingNoPolarizingConfirm(false);
                    }}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded"
                  >
                    I’m sure
                  </Button>
                </div>
              </div>
            </div>
          )}
          

          {/* --- Subcategory Confirmation Overlay --- */}
          {showSubcategoryPopup && pendingSubcategoryAnnotation && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm transition-opacity duration-300">
              <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center animate-fadeIn">
                <h2 className="text-2xl font-bold mb-3 text-gray-900">Are you sure?</h2>

                <p className="text-sm text-gray-700 mb-4 leading-relaxed">
                  Selecting this option will trigger a closer review of your work.
                  <br /><br />
                  You selected <strong>{pendingSubcategoryCopy?.title}</strong>. Confirm if this highlight truly matches the definition below.
                  Otherwise, click <strong>Cancel</strong> and choose a different subcategory.
                </p>

                <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 text-left mb-4">
                  <p className="text-xs text-gray-500 mb-1 font-semibold">Selected text</p>
                  <p className="text-sm text-gray-800 break-words">“{pendingSubcategoryAnnotation.text}”</p>
                </div>

                <div className="text-left mb-5">
                  <p className="text-sm text-gray-800 leading-relaxed">
                    {pendingSubcategoryCopy?.description}
                  </p>

                  {pendingSubcategoryCopy?.examples?.length > 0 && (
                    <div className="mt-3">
                      <p className="text-xs text-gray-500 font-semibold mb-1">Examples</p>
                      <ul className="list-disc list-outside ml-5 text-sm text-gray-700 space-y-1">
                        {pendingSubcategoryCopy.examples.slice(0, 3).map((ex, i) => (
                          <li key={i}>{ex}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                <div className="flex justify-center space-x-4">
                  <Button
                    onClick={() => {
                      setShowSubcategoryPopup(false);
                      setPendingSubcategoryAnnotation(null);
                      setSelectedSubcategory("");
                    }}
                    className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded"
                  >
                    Cancel
                  </Button>

                  <Button
                    onClick={() => {
                      if (pendingSubcategoryAnnotation) {
                        saveAnnotation({
                          articleId: pendingSubcategoryAnnotation.articleId,
                          title: pendingSubcategoryAnnotation.title,
                          text: pendingSubcategoryAnnotation.text,
                          category: pendingSubcategoryAnnotation.category,
                          subcategory: pendingSubcategoryAnnotation.subcategory,
                          paragraphIndex: pendingSubcategoryAnnotation.paragraphIndex,
                        });
                      }
                      setShowSubcategoryPopup(false);
                      setPendingSubcategoryAnnotation(null);
                    }}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded"
                  >
                    I’m sure
                  </Button>
                </div>
              </div>
            </div>
          )}

            {/* Instructions Sidebar */}
            <div className={`w-1/4 p-4 bg-gray-200 shadow-md transition-all duration-300 ${showRightInstructions ? "visible opacity-100 pointer-events-auto" : "invisible opacity-0 pointer-events-none"}`}>
                <h3 className="text-lg font-bold mb-2">Annotation Guide</h3>
                <p className="text-sm mb-2">Use the following categories for labeling:</p>

      {/* Persuasive Propaganda Section */}
<div className="bg-yellow-100 p-4 rounded mb-4">
  <strong className="text-yellow-700 text-center block mb-4 text-lg font-semibold">
    Persuasive Propaganda
  </strong>

  <p className="category-definition-pp text-sm text-gray-700 text-left mt-3 mb-4 leading-relaxed">Uses repeated, agenda-driven messaging to shape people’s beliefs or loyalty over time. It often relies on selective facts, framing, slogans, or repetition. The main goal is persuasion.</p>

  <DropdownItem title="Exaggeration" openTitle={openDropdown} setOpenTitle={setOpenDropdown} color="yellow">
    <div className="mt-2 ml-4 text-left text-gray-800 space-y-2 py-3">
      <p className="text-base leading-relaxed">
        When something is made to sound artificially much bigger, better, or worse
        than it really is — or, the opposite, made to sound smaller or less serious
        than it actually is.
      </p>
      <div className="text-sm leading-relaxed text-gray-700">
        <p className="font-semibold">Examples:</p>
        <ul className="list-disc list-outside ml-5 space-y-1">
          <li>“A local protest ignited waves of outrage and sent shockwaves through the nation.”</li>
          <li>“This minor disagreement has become a national catastrophe, easily the worst of the modern era.”</li>
          <li>“The present scandal is nothing — just political theater — and most Americans aren’t even aware of it.”</li>
        </ul>
      </div>
    </div>
  </DropdownItem>

  <DropdownItem title="Slogans" openTitle={openDropdown} setOpenTitle={setOpenDropdown} color="yellow">
    <div className="mt-2 ml-4 text-left text-gray-800 space-y-2 py-3">
      <p className="text-base leading-relaxed">
        A short, memorable phrase used to spark emotion or support a cause.
        Slogans simplify complex ideas into a few words and can promote unity,
        nationalism, or other sentiments. They can be positive or negative in tone.
      </p>
      <div className="text-sm leading-relaxed text-gray-700">
        <p className="font-semibold">Examples:</p>
        <ul className="list-disc list-outside ml-5 space-y-1">
          <li>“Make America Great Again” / “America First”</li>
          <li>“No Justice, No Peace”</li>
          <li>“Occupy Wall Street — We Are the 99%”</li>
        </ul>
      </div>
    </div>
  </DropdownItem>

  <DropdownItem title="Bandwagon" openTitle={openDropdown} setOpenTitle={setOpenDropdown} color="yellow">
    <div className="mt-2 ml-4 text-left text-gray-800 space-y-2 py-3">
      <p className="text-base leading-relaxed">
        When people are told to support something just because “everyone else”
        already supports it. The message is: if many others believe it, you should too.
        This relies on social pressure and popularity, not evidence.
      </p>
      <div className="text-sm leading-relaxed text-gray-700">
        <p className="font-semibold">Examples:</p>
        <ul className="list-disc list-outside ml-5 space-y-1">
          <li>“Most Americans back this plan, polls show.”</li>
          <li>“As the Senator emphasized, ‘every true Republican supports this cause.’”</li>
          <li>“No serious economist still believes raising taxes is a good idea.”</li>
        </ul>
      </div>
    </div>
  </DropdownItem>

  <DropdownItem title="Casual Oversimplification" openTitle={openDropdown} setOpenTitle={setOpenDropdown} color="yellow">
    <div className="mt-2 ml-4 text-left text-gray-800 space-y-2 py-3">
      <p className="text-base leading-relaxed">
        When a complex issue is blamed on just one cause or explained with one
        simple answer, ignoring all the other factors that are probably involved.
      </p>
      <div className="text-sm leading-relaxed text-gray-700">
        <p className="font-semibold">Examples:</p>
        <ul className="list-disc list-outside ml-5 space-y-1">
          <li>“The media is the only reason the nation is divided.”</li>
          <li>“Inflation rose solely because of the president’s policies.”</li>
          <li>“Crime is up because of progressive prosecutors.”</li>
        </ul>
      </div>
    </div>
  </DropdownItem>

  <DropdownItem title="Doubt" openTitle={openDropdown} setOpenTitle={setOpenDropdown} color="yellow">
    <div className="mt-2 ml-4 text-left text-gray-800 space-y-2 py-3">
      <p className="text-base leading-relaxed">
        Language that tries to make the audience question whether a person,
        group, or institution is competent, honest, or legitimate.
      </p>
      <div className="text-sm leading-relaxed text-gray-700">
        <p className="font-semibold">Examples:</p>
        <ul className="list-disc list-outside ml-5 space-y-1">
          <li>“Is he really ready to be the Mayor?”</li>
          <li>“Is this leader even capable of running the country?”</li>
          <li>“Some experts question whether the agency’s data can be trusted.”</li>
        </ul>
      </div>
    </div>
  </DropdownItem>
</div>

{/* Inflammatory Language Section */}
<div className="bg-red-100 p-4 rounded mb-6">
  <strong className="text-red-700 text-center block mb-4 text-lg font-semibold">
    Inflammatory Language
  </strong>

  <p className="category-definition-il text-sm text-gray-700 text-left mt-3 mb-4 leading-relaxed">Uses hostile, charged, or insulting words to trigger an immediate emotional reaction. It is meant to spark anger, fear, outrage, or division. The main goal is provocation.</p>

  <DropdownItem title="Name-Calling" openTitle={openDropdown} setOpenTitle={setOpenDropdown} color="red">
    <div className="mt-2 ml-4 text-left text-gray-800 space-y-2 py-3">
      <p className="text-base leading-relaxed">
        Using a loaded positive or negative label to shape how the audience feels
        about a person, group, or idea. Instead of giving evidence, the speaker
        uses emotionally charged wording to discredit or glorify.
      </p>
      <div className="text-sm leading-relaxed text-gray-700">
        <p className="font-semibold">Examples:</p>
        <ul className="list-disc list-outside ml-5 space-y-1">
          <li>“The movement, composed largely of radical extremists, has demanded sweeping reform.”</li>
          <li>“Big-money interests continue to profit during the crisis.”</li>
          <li>“The oft-labeled terrorist sympathizers took to the streets in the latest wave of protests.”</li>
        </ul>
      </div>
    </div>
  </DropdownItem>

  <DropdownItem title="Demonization" openTitle={openDropdown} setOpenTitle={setOpenDropdown} color="red">
    <div className="mt-2 ml-4 text-left text-gray-800 space-y-2 py-3">
      <p className="text-base leading-relaxed">
        Describing people or groups as evil, dangerous, corrupt, disgusting,
        or less than human. The goal is to turn the audience against the target
        by making them sound like a threat to society.
      </p>
      <div className="text-sm leading-relaxed text-gray-700">
        <p className="font-semibold">Examples:</p>
        <ul className="list-disc list-outside ml-5 space-y-1">
          <li>“The nation’s bureaucrats are bleeding taxpayers dry.”</li>
          <li>“Migrants are parasites stealing American jobs.”</li>
          <li>“These politicians are eating away at the heart of this nation from within.”</li>
        </ul>
      </div>
    </div>
  </DropdownItem>

  <DropdownItem title="Scapegoating" openTitle={openDropdown} setOpenTitle={setOpenDropdown} color="red">
    <div className="mt-2 ml-4 text-left text-gray-800 space-y-2 py-3">
      <p className="text-base leading-relaxed">
        Blaming an entire group for a broad problem or crisis. The group is
        framed as the main cause of widespread harm or decline. This is almost
        always aimed at groups (not individuals) and links them to larger
        social, economic, or moral problems.
      </p>
      <div className="text-sm leading-relaxed text-gray-700">
        <p className="font-semibold">Examples:</p>
        <ul className="list-disc list-outside ml-5 space-y-1">
          <li>“The rising rents — driven as always by greedy landlords — represent a severe strain on families.”</li>
          <li>“Teachers’ unions are the reason kids are failing in school.”</li>
          <li>“Homelessness continues to rise because city officials refuse to enforce basic laws.”</li>
        </ul>
      </div>
    </div>
  </DropdownItem>
</div>
                
                <Button onClick={() => 
                  setShowRightInstructions(false)} className="bg-gray-600 text-white w-full">Close Guide</Button>
            </div>
            

            {/* Main Content */}
            <div className="w-3/4 max-w-2xl bg-white p-6 rounded-lg shadow-md text-center">
                <Button onClick={() => setShowRightInstructions(!showRightInstructions)} className="bg-blue-600 text-white mb-4">
                    {showRightInstructions ? "Hide Instructions" : "Show Instructions"}
                </Button>
                {articles.length > 0 && (
                    <Card>
                        <h2 className="text-xl font-bold text-gray-900 mb-2">
                          {/*Calls the article capitalization function*/}
                            {titleCapitalization(articles[currentArticleIndex]?.title)}
                        </h2>
                        <CardContent>
                        {paragraphs.slice(0, currentParagraphIndex + 1).map((para, idx) => (
  <p
    key={idx}
    className="text-gray-700 mb-4"
    onMouseUp={() => handleTextSelection(idx)}
  >
    {para}
  </p>
))}
                        </CardContent>
                    </Card>
                )}

                {hasMoreParagraphs && hasAnnotationInCurrentParagraph && (
                  <div className="mt-4 flex justify-center">
                    <Button
                      onClick={handleUnlockNextParagraph}
                      className="bg-gray-800 text-white"
                    >
                      Submit &amp; show next paragraph
                    </Button>
                  </div>
                )}

                {/* Annotation Buttons */}
                <div className="mt-4 flex justify-center space-x-4">
                    <Button onClick={() => handleCategoryButtonClick("Inflammatory_Language")} className="bg-red-500">
                      Inflammatory Language
                    </Button>
                    <Button onClick={() => handleCategoryButtonClick("Persuasive_Propaganda")} className="!bg-yellow-500">
                        Persuasive Propaganda
                    </Button>
                    <Button onClick={() => handleCategoryButtonClick("No_Polarizing_Language")} className="!bg-emerald-700/60">
                        No polarizing language
                    </Button>
                </div>


{selectedText &&  (
  <div className="mt-4 flex flex-col items-center">
   {/* Old code that displays selected text and word count above annotation buttons
   
   <p className="text-sm text-gray-700 mb-2">
      Selected Text: "{selectedText}"
    </p>
    {wordCount > 0 && (
    <p
      className={`text-xs mb-2 ${
        wordCount < MIN_WORDS || wordCount > MAX_WORDS
          ? "text-red-600"
          : "text-green-600"
      }`}
    >
      Word Count: {wordCount} (must be {MIN_WORDS}–{MAX_WORDS})
    </p>
   )} */}
    <select
      className="p-2 border border-gray-300 rounded-md mb-2"
      value={selectedCategory}
      onChange={handleCategoryChange}
    >
      <option value="">Select a Category</option>
      {Object.keys(categoryOptions).map((category) => (
        <option key={category} value={category}>
          {category}
        </option>
      ))}
    </select>
{selectedCategory && categoryOptions[selectedCategory] && (
  <select
    className="p-2 border border-gray-300 rounded-md mb-2"
    value={selectedSubcategory}
    onChange={handleSubcategoryChange}
  >
    <option value="">Select a Subcategory</option>
    {categoryOptions[selectedCategory].map((subcategory) => (
      <option key={subcategory} value={subcategory}>
        {subcategory}
      </option>
    ))}
  </select>
)}
  </div>
)}

{/* Display Saved Annotations */}
{textAnnotations[articles[currentArticleIndex]?.id]?.length > 0 && (
  <div className="mt-6 bg-gray-100 p-4 rounded-md">
    <h3 className="text-lg font-semibold">Annotated Text Excerpts:</h3>
    {textAnnotations[articles[currentArticleIndex]?.id].map((annotation, index) => (
      <div key={index} className="flex justify-between items-center mt-2">
        <p className="text-sm text-red-600">
          "{annotation.text}" – {annotation.category} → {annotation.subcategory}
        </p>
        <Button
          onClick={() => handleRemoveAnnotation(articles[currentArticleIndex]?.id, index)}
          className="bg-gray-400 text-white text-xs px-2 py-1 rounded"
        >
          Remove
        </Button>
      </div>
    ))}
  </div>
)}


            {/* Survey Form */}
        {showSurvey ? (
          <div className="mt-8 text-left">
            <h3 className="text-lg font-semibold mb-2">🧠 Post-Annotation Survey</h3>

            <label className="block mt-4">1. How confident are you that there is polarizing language (either persuasive propaganda or inflammatory language) in this article?</label>
            <div className="mt-2 space-y-1">
  {[1, 2, 3, 4, 5].map((val) => (
    <label key={val} className="block text-sm">
      <input
        type="radio"
        name="confidence"
        value={val}
        checked={confidence === val}
        onChange={() => setConfidence(val)}
        className="mr-2"
      />
      {val} – {["Not at all confident that there is polarizing language", "Slightly confident that there is polarizing language", "Moderately confident that there is polarizing language", "Very confident that there is polarizing language", "Extremely confident that there is polarizing language"][val - 1]}
    </label>
  ))}
</div>

            <label className="block mt-4">2. To what extent does this article seem biased, one-sided, or misleading in how it presents information?</label>
            <div className="mt-2 space-y-1">
  {[1, 2, 3, 4, 5].map((val) => (
    <label key={val} className="block text-sm"> 
      <input
        type="radio"
        name="bias"
        value={val}
        checked={bias === val}
        onChange={() => setBias(val)}
        className="mr-2"
      />
      {val} – {["Not at all biased", "Slightly biased", "Moderately biased", "Very biased", "Extremely biased"][val - 1]}
    </label>
  ))}
</div>

<label className="block mt-4">
  3. Why did you tag this way? What specific phrases, tone choices, or examples made it stand out to you? You might reference particular sentences, framing choices, or emotional wording that influenced your decision.
</label>
<p className="text-sm text-gray-600 mb-1">
  Character count: {countCharacters(openFeedback)}
</p>
<textarea
  value={openFeedback}
  onChange={(e) => setOpenFeedback(e.target.value)}
  rows={6}
  className="w-full p-2 border rounded"
  placeholder="For example: “I tagged the phrase ‘reckless and corrupt regime’ as inflammatory because it uses strong language to attack without evidence."
></textarea>

<Button
  onClick={handleNextArticle}
  className="mt-4 bg-green-600 text-white"
  disabled={
    confidence === 0 ||
    bias === 0
  }
>
  {currentArticleIndex < articles.length - 1
    ? "Submit Survey & Load Next Article"
    : "Finish"}
</Button>
          </div>
        ) : (
          !hasMoreParagraphs && hasAnnotationInCurrentParagraph && (
            <div className="mt-6">
              <Button onClick={handleNextArticle} className="bg-blue-500">Submit</Button>
            </div>
          )
        )}
            </div>


{/* Instructions Panel on Right */}
<div className={`w-1/4 p-4 bg-blue transition-all duration-300 ${showRightInstructions ? "visible opacity-100 pointer-events-auto" : "invisible opacity-0 pointer-events-none"}`}>
    <h3 className="text-lg font-bold mb-3">Instructions</h3>
    <p className="text-sm ml-3 text-left">
    You will annotate <strong>1 news article</strong>. Please follow these steps for each paragraph:
  </p>

<div className="mt-4">
  <DropdownItem
    title="Category Definitions"
    openTitle={openDropdown}
    setOpenTitle={setOpenDropdown}
    color="blue"
  >
    <div className="mt-2 ml-1 text-left text-gray-800 space-y-4 py-2">
      <div>
        <p className="font-bold text-yellow-700 mb-1">Persuasive Propaganda</p>
        <p className="text-sm text-gray-700 leading-relaxed">
          Uses repeated, agenda-driven messaging to shape people’s beliefs or loyalty over time. It often relies on selective facts, framing, slogans, or repetition. The main goal is persuasion.
        </p>
      </div>

      <div>
        <p className="font-bold text-red-700 mb-1">Inflammatory Language</p>
        <p className="text-sm text-gray-700 leading-relaxed">
          Uses hostile, charged, or insulting words to trigger an immediate emotional reaction. It is meant to spark anger, fear, outrage, or division. The main goal is provocation.
        </p>
      </div>

      <p className="text-xs text-gray-500">
        Please read these carefully before making decisions.
      </p>
    </div>
  </DropdownItem>
</div>
  <div className="h-4 text-left" />
  <div className="h-4 text-left" />
  <ul className="list-decimal text-left ml-5 list-inside text-sm space-y-1">
    <li>
      <strong>Highlight a section of text</strong> between 1 and 25 words that you want to annotate. Only highlight the most prominent category.
    </li>
    <div className="h-3" />
    <li>
      Scroll down and <strong>select a category</strong> using either the buttons or the dropdown menu (e.g., <em>Imflammatory Language</em> or <em>Persuasive Propaganda</em>).
    </li>
    <div className="h-3" />
    <li>
      <strong>Choose a subcategory</strong> (e.g., <em>Exaggeration</em>). Your annotation will be saved automatically.
    </li>
    <div className="h-3" />
    <li>
      Click <strong>"Submit & show next paragraph"</strong> to move to the next paragraph.
    </li>
    <div className="h-3" />
    <li>
      After making 1 annotation per paragraph select <strong>"Submit"</strong> to move on to the post-annotation survey.
    </li>
    <div className="h-3" />
    <li>
      <strong>Only mark polarizing language if you are sure there is polarizing language. Otherwise choose "No polarizing language." do NOT mark both in the same paragraph </strong>
    </li>
    <div className="h-3" />
    <li>
      <strong>Treat text within quotations the same way as the rest of the text </strong>
    </li>
    <div className="h-3" />
  </ul>
  <p></p>
<div className="h-4" />
<p></p>
  <p className="text-sm text-gray-500 italic">
    Make sure your highlights are thoughtful and fall within the required word range—your input helps us better understand how people detect biased or misleading content.
  </p>
</div>

{/* Sticky Selected Text & Word Count */}
{(selectedText || wordCount > 0) && (
  <div className="fixed bottom-4 right-4 bg-white shadow-lg rounded-lg p-4 border border-gray-300 w-64 z-50">
    {selectedText && (
      <p className="text-sm text-gray-700 mb-2 break-words">
        <strong>Selected:</strong> "{selectedText}"
      </p>
    )}
    {wordCount > 0 && (
      <p
        className={`text-xs ${
          wordCount < MIN_WORDS || wordCount > MAX_WORDS
            ? "text-red-600"
            : "text-green-600"
        }`}
      >
        Word Count: {wordCount} (must be {MIN_WORDS}–{MAX_WORDS})
      </p>
    )}
  </div>
)}

        </div>
    );
  }


export default function NewsAnnotationTool() {
  return <ToolMain />;
}
